import { FormGroup, FormControl, Validators } from "@angular/forms"
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core'
import { Router, NavigationEnd } from "@angular/router"
//import { filter } from "rxjs/operators"
import { Subscription } from 'rxjs'
import { ViewService } from './view.service'
import { ViewColumn, ViewParameter } from './view.model';

import { environment } from "../../../environments/environment"
import { Ng4LoadingSpinnerService } from "ng4-loading-spinner";
import { AppService } from "src/app/server/app.service";
import { filter } from "rxjs/operators"
export let isDebugMode = environment.isDebugMode
declare var $: any

@Component({
  selector: 'flow-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss']
})
export class ViewComponent implements OnInit {


  @Input() items: any
  @Input() viewid: number
  @Input() keys: any[] = []
  @Input() itemsPage: number
  @Input() iconHome: boolean = true
  @Input() iconNew: boolean = false
  @Input() striped: boolean = true
  @Input() filterable: boolean = true
  @Input() filterForm: FormGroup

  @Output() eventSelect = new EventEmitter()
  @Output() eventRemove = new EventEmitter()
  @Output() eventNewItem = new EventEmitter()
  @Output() eventResetFilters = new EventEmitter()

  private subscriptions: Subscription[] = []
  parameters: ViewParameter
  colspan: number = 1
  filter: any
  columns: ViewColumn[]
  records: any[]
  message: string = "Não há registros selecionados"
  lastUrl: string
  filterValues: number = 0
  collapsed: boolean = true
  key: string = ""
  reverse: boolean = false
  p: number = 1 // Aqui inicializa a paginação, guardar esse valor em algum lugar para quando
  isCheckAll: boolean = false
  myjson: any = JSON;

  constructor(
    private appService: AppService,
    private viewService: ViewService,
    private loading: Ng4LoadingSpinnerService,
    private router: Router
  ) {

    if (this.appService.session) {

      this.parameters = {
        viewid: this.viewid,
        userid: this.appService.session.userid,
        keycolumn: "",
        keyorder: 0,
        pagenumber: 0
      }

    }

    /*
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((res: NavigationEnd) => {
        this.lastUrl = res.url        
      })
      */


      this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((res: NavigationEnd) => {
          this.lastUrl = res.url
      })
      

      

  }
  ngOnInit() {
    isDebugMode ? console.log(`ngOnInit()`) : undefined
    this.subscriptions.push()
  }
  ngAfterViewInit() {
    this.getView()
  }
  ngOnDestroy() {
    isDebugMode ? console.log(`ngOnDestroy()`) : undefined
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe()
    })
  }
  getView() {
    this.loading.show()
    try {

      this.viewService.viewid  = this.viewid
      this.viewService.groupid = this.appService.session.groupid

      setTimeout(() => {

        if (this.viewid) {

          this.viewService
            .getView()
            .subscribe(
              data => {

                new Promise<void>(
                  (resolve, reject) => {
                    this.columns = data[1]
                    this.colspan = this.columns.length

                    if (this.filterable) {                     

                      if (data[2]) {
                        data[2].forEach(item => {

                          if (this.filterForm.controls[item.key]) {
                            this.filterForm.controls[item.key].setValue(item.value)
                            this.filterValues += 1
                          }
                          
                        })
                      }
                    }

                    resolve()
                  })
                  .then((res) => {
                    this.getData()
                    this.loading.hide()
                  })
                  .catch((err) => {
                    console.log('Error promisse ', err)
                  })

              },
              error => {
                console.log(error)
                this.records = undefined
                this.message = "Erro na requisição, não foi possível selecionar os registros"
                this.loading.hide()
              },
              () => {
                this.loading.hide()
              }
            )
        } else {
          this.loading.hide()
        }


      }, 200);





    } catch (error) {
      isDebugMode ? console.error(error) : undefined
      this.loading.hide()
      this.message = "Erro na requisição, não foi possível selecionar os registros"
    }
  }
  getData() {
    isDebugMode ? console.log(`getData()`) : undefined

    this.loading.show()

    this.records = []

    if (this.items.length > 0) {
      this.records = this.items
      this.loading.hide()
    } else {
      if (this.viewid && this.viewid != 0) {

        let filterFormObject = []
        this.filterValues = 0

        //console.log(this.filterForm.getRawValue())

        if (this.filterForm) {
          Object.keys(this.filterForm.value).forEach(key => {
            if (this.filterForm.value[key] && this.filterForm.value[key] !== "") {
              this.filterValues += 1
              filterFormObject.push({ key: key, value: this.filterForm.value[key] })
            }
          })
        }

        if (this.keys) {
          this.keys.forEach(element => {
            if (element.key) {
              filterFormObject.push({ key: element.key, value: element.value })
              this.filterValues += 1
            }
          })
        }


        setTimeout(() => {
          try {
            this.viewService.groupid = this.appService.session.groupid
            this.viewService.viewid = this.viewid
            //this.getParam()

            console.log( JSON.stringify( filterFormObject ))

            this.viewService
              .getData(filterFormObject)
              .subscribe(
                data => {
                  this.getParam()
                  //this.result = JSON.parse(data.output.result)
                  this.records = data
                  if (!this.collapsed) {
                    this.collapseFilter()
                  }
                  //this.parameters.filters = JSON.stringify(filterFormObject)
                  //console.log(this.parameters.filters)
                  //console.log(JSON.stringify(filterFormObject))
                  this.setParam('getData')
                  this.loading.hide()
                },
                error => {
                  console.log("Erro na requisição, não foi possível selecionar os registros")
                  console.log(error)
                  this.records = undefined
                  this.message = "Erro na requisição, não foi possível selecionar os registros"
                  this.loading.hide()
                },
                () => {
                  this.loading.hide()
                }
              )
          } catch (error) {
            isDebugMode ? console.error(error) : undefined
            this.loading.hide()
            this.message = "Erro na requisição, não foi possível selecionar os registros"
          }
        }, 5)
      }
    }
  }
  getParam() {
    isDebugMode ? console.log(`View getParam( groupid : ${this.appService.session.groupid}, viewid : ${this.viewid} )`) : undefined

    if (this.viewid) {

      this.viewService.getParam().subscribe(
        data => {
          if (data[0]) {
            this.parameters = data[0]
            this.p = this.parameters["pagenumber"]
            this.key = this.parameters["keycolumn"]
            this.reverse = this.parameters["keyorder"] === 1
          } else {
            this.p = 1
            this.key = ""
            this.reverse = false
          }

        },
        res => {
          this.message = "Erro na requisição, não foi possível selecionar os registros"
          console.log("Error", this.message)
        }
      )

    }

  }
  setParam(sender) {
    isDebugMode ? console.log(`setParam(sender:${sender})`) : undefined

    //console.log(this.parameters)

    this.viewService.setParam(this.parameters).subscribe(
      data => {
        //console.log('setParam().data', data)
      },
      error => {
        console.error(error)
      }
    )
  }
  collapseFilter() {
    isDebugMode ? console.log("collapseFilter()") : undefined

    if ($("#" + this.viewid).hasClass("hide")) {
      $("#" + this.viewid).addClass("zoomIn")
      $("#" + this.viewid).removeClass("hide")
      this.collapsed = false

    } else {
      this.collapsed = true
      $("#" + this.viewid).removeClass("zoomIn")
      $("#" + this.viewid).addClass("zoomOut")
      setTimeout(() => {
        $("#" + this.viewid).addClass("hide")
        $("#" + this.viewid).removeClass("zoomOut")
      }, 200)
    }
  }
  sortColumn(column) {
    isDebugMode ? console.log("sortColumn()") : undefined

    if (column.typecol == 0) {
      this.key = column.field
      this.reverse = !this.reverse
    }
    this.parameters["viewid"] = this.viewid
    this.parameters["keycolumn"] = this.key
    this.parameters["keyorder"] = this.reverse ? 1 : 0

    this.setParam(2)
  }
  isAllChecked() {
    isDebugMode ? console.log("isAllChecked()") : undefined
    return this.records.every(_ => _.state)
  }
  checkAll(ev) {
    isDebugMode ? console.log("checkAll()") : undefined
    this.isCheckAll = true
    this.records.forEach(x => (x.state = ev.target.checked))
  }
  itemChecked() {
    isDebugMode ? console.log("itemChecked()") : undefined
    this.isCheckAll = this.isAllChecked()
  }
  pageChanged(evento) {
    isDebugMode ? console.log("pageChanged()", evento) : undefined
    this.parameters["pagenumber"] = evento
    this.p = evento
    this.setParam(3)
  }
  dblclick(row, sender) {
    isDebugMode ? console.log("dblclick()") : undefined
    let keysvalues = ""
    this.columns.filter(c => c["keyfield"] === 1).forEach(c => {
      keysvalues += row[c["field"]] + "/"
    })
    this.router.navigate([`/${this.lastUrl}/${keysvalues}`])
  }
  removeRow(row) {
    isDebugMode ? console.log("removeRow()") : undefined
    this.eventRemove.next(row)
  }
  selectRow(row) {
    isDebugMode ? console.log("selectRow()") : undefined
    this.eventSelect.emit(row)
  }
  newItem() {
    this.eventNewItem.emit(true)
  }
  resetFilter() {
    isDebugMode ? console.log("resetFilter()") : undefined
    this.eventResetFilters.emit(true)
    this.filterValues = 0
    this.filterForm.reset()
  }


}
